import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { SessionStorageService, SessionTimeoutService } from '../_services';

@Injectable()
export class AuthGuard implements CanActivate {
  private _timeoutExpired: boolean = false;

  constructor(
    private router: Router,
    private sessionState: SessionStorageService,
    private sessionTimeoutService: SessionTimeoutService
  ) {
    const subscription = sessionTimeoutService.sessionTimedOut.subscribe((): void => {
      this._timeoutExpired = true;
      subscription.unsubscribe();
    });
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const redirectToLogin: boolean = !this.sessionState.getAuthToken() || this._timeoutExpired;
    if (redirectToLogin) {
      this.sessionState.clearAll();
      this.router.navigate(['/login']);
      this.sessionTimeoutService.stopTimer();
    }
    return !redirectToLogin;
  }
}



// WEBPACK FOOTER //
// ./src/app/_guards/auth.guard.ts